import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Claim } from '../../../models/claim.model';

@Component({
  selector: 'app-eventsearch-postedclaimreversal',
  templateUrl: './eventsearch-postedclaimreversal.component.html',
})
export class EventSearchPostedClaimReversalComponent implements OnInit {
  @Input() postedClaimReversalModal: boolean;
  @Output() postedClaimReversalChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() selectedClaim: Claim;
  @Output() onModalAction: EventEmitter<any> = new EventEmitter<any>();

  @Input() firstReversal: boolean
  @Output() firstReversalChange = new EventEmitter<boolean>()


  constructor() {
  }

  ngOnInit() {
  }

  cancelClick() {
    this.postedClaimReversalModal = false;
    this.postedClaimReversalChange.emit(this.postedClaimReversalModal);
    this.onModalAction.emit({ type: 'cancel' })
  }

  submitClick() {
    this.firstReversalChange.emit(false)
    this.onModalAction.emit({ type: 'submit', value: 0 })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/eventsearch-postedclaimreversal/eventsearch-postedclaimreversal.component.ts